import { CASE_METADATA_TAG, CASES_TAG } from '@/api';
import { api } from '@/api';
import { PaginationProductTypeKeys } from '@/api';

export type CaseCloneResponse = {
  caseId: string;
};

type CaseCloneProps = {
  abortController?: AbortController;
  assignedTo?: string | null;
  caseReference: string;
  dueDate: string; // '2025-01-01'
  isUrgent: boolean;
  gRef?: string | null;
  paginationProduct: PaginationProductTypeKeys;
  cloneFromCase: string; // case reference of case to clone
};

const caseCloneApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postCaseClone: builder.query<CaseCloneResponse, CaseCloneProps>({
      query: ({
        abortController = new AbortController(),
        assignedTo,
        caseReference,
        dueDate,
        isUrgent,
        gRef,
        paginationProduct,
        cloneFromCase
      }: CaseCloneProps) => ({
        url: 'case/clone',
        method: 'POST',
        body: {
          assigned_to: assignedTo || null,
          case_reference: caseReference,
          due_date: dueDate,
          is_urgent: isUrgent,
          g_ref: gRef || null,
          pagination_product: paginationProduct,
          externalIdToClone: cloneFromCase
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(api.util.invalidateTags([CASES_TAG, CASE_METADATA_TAG]));
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postCaseClone in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostCaseCloneQuery } = caseCloneApi;
